import { QuotationNote, mapQuotationNotes } from "./QuotationNoteType";
import { mapQuotationTermData, mapSOWDetailData, mapSOWSimpleData, QuotationTermData, SOWDetailData, SOWSimpleData } from "./QuotationType";


/* **************************************************** Quotation template cover page */
export interface QuotationTemplateCoverPage {
    comapany_logo: string | null;
    comapany_name: string | null;
    project_description: string | null;
    project_address: string | null;
    client_name: string | null;
}

export const mapQuotationTemplateCoverPage = (data: any): QuotationTemplateCoverPage => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: QuotationTemplateCoverPage = {
        comapany_logo: data.comapany_logo || null,
        comapany_name: data.comapany_name || null,
        project_description: data.project_description || null,
        project_address: data.project_address || null,
        client_name: data.client_name || null,
    };

    return res;
};
/* **************************************************** */


/* **************************************************** Quotation template item list */
export interface QuotationTemplateItemList {
    simple_data: SOWSimpleData | null;
    detail_data: SOWDetailData | null;
}

export const mapQuotationTemplateItemList = (data: any): QuotationTemplateItemList => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: QuotationTemplateItemList = {
        simple_data: data.simple_data ? mapSOWSimpleData(data.simple_data) : null,
        detail_data: data.detail_data ? mapSOWDetailData(data.detail_data) : null,
    };

    return res;
};
/* **************************************************** */


/* **************************************************** Quotation template */
export interface QuotationTemplate {
    id: number;
    quotation_template_name: string;
    status: 1 | 0;
    cover_page_data: QuotationTemplateCoverPage | null;
    item_list: QuotationTemplateItemList | null;
    term_data: QuotationTermData | null;
    note_list: QuotationNote[];
}

export const mapQuotationTemplate = (data: any): QuotationTemplate => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: QuotationTemplate = {
        id: data.id,
        quotation_template_name: data.quotation_template_name,
        status: data.status,
        cover_page_data: data.cover_page_data ? mapQuotationTemplateCoverPage(data.cover_page_data) : null,
        item_list: data.item_list ? mapQuotationTemplateItemList(data.item_list) : null,
        term_data: data.term_data ? mapQuotationTermData(data.term_data) : null,
        note_list: Array.isArray(data.note_list) ? mapQuotationNotes(data.note_list) : [],
    };

    return res;
};

export const mapQuotationTemplates = (data: any[]): QuotationTemplate[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapQuotationTemplate);
};
/* **************************************************** */